/**
 * Chains added by Lumia on top of the upstream list.
 *
 * Kept in a separate file so that the change to supportedChains.ts is a single import and a
 * single spread, which keeps rebasing onto upstream cheap.
 *
 * Contract addresses need no special handling here: @safe-global/safe-deployments (1.37.62+)
 * ships networkAddresses for Lumia Prism, so every resolver finds the canonical Safe 1.4.1
 * deployments through the package, the same as for any other supported chain.
 * src/config/__tests__/lumiaContracts.test.ts guards that version floor.
 */
export const LUMIA_CHAINS = [
  {
    chainId: '994873017',
    chainName: 'Lumia Prism',
    description: 'Lumia Prism mainnet',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Lumia',
      symbol: 'LUMIA',
      decimals: 18,
      logoUri: null,
    },
    transactionService: '',
    blockExplorerUriTemplate: {
      address: 'https://explorer.lumia.org/address/{{address}}',
      txHash: 'https://explorer.lumia.org/tx/{{txHash}}',
      api: 'https://explorer.lumia.org/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: ['CONTRACT_INTERACTION', 'EIP1271', 'EIP1559', 'ERC721', 'SAFE_TX_GAS_OPTIONAL'],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet-rpc.lumia.org',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet-rpc.lumia.org',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet-rpc.lumia.org',
    },
    shortName: 'lumiaprism',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#1B1B1F',
    },
  },
]
